import { AbstractSearchCriteria } from './abstract-search-criteria';

export class CurrencySearchCriteria extends AbstractSearchCriteria {
    code: string = '';
    name: string = '';
    category: string = '';
}
